"use client";

import React, { useEffect, useState } from "react";

// Shown on every page while the sales admin is viewing the site as a customer
// (lib/admin_view_as.js). Reads the readable hint cookie so ordinary visitors
// cost nothing; the hint alone grants nothing — the server only honours the
// signed cookie, and only for the admin who set it.
export default function AdminViewBanner() {
  const [label, setLabel] = useState(null);
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    const m = document.cookie.match(/(?:^|;\s*)il_admin_view_hint=([^;]*)/);
    if (m && m[1]) { try { setLabel(decodeURIComponent(m[1])); } catch { setLabel(m[1]); } }
  }, []);

  if (!label) return null;

  const exit = async () => {
    setExiting(true);
    await fetch("/api/admin/accounts/view-as", { method: "DELETE", credentials: "include" }).catch(() => {});
    window.location.href = "/admin/accounts";
  };
  const link = { color: "#1a1206", fontWeight: 800, textDecoration: "underline" };

  return (
    <div style={{ position: "sticky", top: 0, zIndex: 10000, display: "flex", alignItems: "center", justifyContent: "center", flexWrap: "wrap", gap: 12,
      padding: "8px 12px", background: "#f5b301", color: "#1a1206", fontSize: 13, fontWeight: 600, textAlign: "center" }}>
      <span>Viewing as <strong>{label}</strong> — changes save to their account.</span>
      <a href="/designs" style={link}>Their designs</a>
      <a href="/admin/accounts" style={link}>Accounts</a>
      <button type="button" onClick={exit} disabled={exiting}
        style={{ padding: "4px 12px", borderRadius: 999, border: "1px solid #1a1206", background: "#1a1206", color: "#f5b301", fontWeight: 800, cursor: "pointer", fontSize: 12 }}>
        {exiting ? "Exiting…" : "Exit"}
      </button>
    </div>
  );
}
